const BASE = ['riskScore'] as const;
export const RISK_SCORE_QUERY_KEYS = {
  getEntityRiskScore: (entityExternalId: string) =>
    [...BASE, 'entity', entityExternalId] as const,
  getHistoricRiskScores: (hashedId: string) =>
    [...BASE, 'historic-risk-scores', hashedId] as const,
};
